// Copyright (c) 2016 Deere & Company

import {FormattedMessage} from 'react-intl';
import React from 'react';

const getColumnHeaders = () =>
    [
        {
            className: 'hours',
            id: 'HOURS'
        },
        {
            className: 'labor-location',
            id: 'LOCATION'
        },
        {
            className: 'type',
            id: 'TYPE'
        },
        {
            className: 'tech-id',
            id: 'TECH_ID'
        },
        {
            className: 'labor-comment',
            id: 'LABOR_COMMENTS'
        }
    ];

const LaborPanelRowHeader = () =>
    <section className='labor-panel-row-header'>
        {
            getColumnHeaders().map(column =>
                <span
                    className={column.className}
                    key={column.id}
                >
                    <FormattedMessage id={column.id}/>
                </span>
            )
        }
    </section>;

LaborPanelRowHeader.displayName = 'LaborPanelRowHeader';

export default LaborPanelRowHeader;



// WEBPACK FOOTER //
// ./src/claim/shared/components/labors-panel/labors-panel-row-header.js